import { render, staticRenderFns } from "./ActualSection.vue?vue&type=template&id=765a053e&"
import script from "./ActualSection.vue?vue&type=script&lang=js&"
export * from "./ActualSection.vue?vue&type=script&lang=js&"
import style0 from "./ActualSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports